// extracted by mini-css-extract-plugin
export default {"container":"TalentData_container__UmWHx","number":"TalentData_number__91QNX","type":"TalentData_type__mYzHF"};